var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.Show),expression:"Show"}],staticClass:"prompts",on:{"click":_vm.close}},[_c('img',{attrs:{"src":require("@/assets/images/url-app.png")}}),_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }